export const SUBJECT_LEVEL = "SUBJECT_LEVEL";
export const COURSE_LEVEL = "COURSE_LEVEL";
export const SUBJECT_DISCIPLINE = "SUBJECT_DISCIPLINE";
export const COURSE_DISCIPLINE = "COURSE_DISCIPLINE";
export const LEVEL = "level";
export const DISCIPLINE = "discipline";
export const PROGRESS_SUMMARY_SUBJECTS = "PROGRESS_SUMMARY_SUBJECTS";
export const PROGRESS_SUMMARY_COURSES = "PROGRESS_SUMMARY_COURSES";
